import React from 'react';
import { useNavigate } from 'react-router-dom';
import './index.less';

const Footer = () => {
  const navigate = useNavigate();

  const handleLinkClick = (path) => {
    // 使用React Router进行页面跳转
    navigate(path);
    // 滚动到页面顶部
    window.scrollTo(0, 0);
  };

  const navigationData = [
    {
      title: "About us",
      links: [
        { label: "Choose us", path: "/choose-us" },
        { label: "Partners", path: "/partners" },
      ],
    },
    {
      title: "Core Technology",
      links: [
        {
          label: "High Speed & High Precision",
          path: "/high-speed-high-precision",
        },
        {
          label: "Advanced Machine Vision",
          path: "/advanced-machine-vision",
        },
        { label: "System Integration", path: "/system-integration" },
        { label: "Intelligent software", path: "/intelligent-software" },
      ],
    },
    {
      title: "Solution",
      links: [
        { label: "3C", path: "/3c" },
        { label: "Medical Products", path: "/medical-products" },
        { label: "Ceramic components", path: "/ceramic-components" },
        { label: "Semiconductor", path: "/semiconductor" },
      ],
    },
    {
      title: "Contact us",
      links: [
        { label: "Contact Us", path: "/contact" },
      ],
    },
  ];

  const locations = [
    {
      title: "Singapore",
      address:
        "1 North Coast Avenue #05-03/04, Woodlands North Coast, Singapore. 737663",
      phone: "(+65)6681 5681",
    },
    {
      title: "Suzhou",
      address:
        "Room 310,311,316,Block B,Building 3, No.99 Suhong West Road, Suzhou Industrial Park",
      phone: "(+86)0512-65165691",
    },
    {
      title: "Beijing",
      address:
        "B1601,16th Floor, Tower B, Beijing.World Trade Center, No.36 North Third Ring East Road, Dongcheng District, Beijing.",
      phone: "(+86)010-58256980",
    },
    {
      title: "Hong Kong",
      address:
        "Room 2214,22/F.Mira Place Tower A No.132 Nathan Road Tsimshatsui Hong Kong.",
      phone: "(+852)3691 8935",
    },
    {
      title: "Shenzhen",
      address:
        "No.F2506B,25F,Building F,Xinghe WORLD,No.1 Yabao Road, Longgang District, Shenzhen.",
      phone: "(+86)0755-33228900",
    },
    {
      title: "Shenzhen",
      address:
        "Room 501, Building 2A, Shangzhi Science and Technology Park, Guangming District, Shenzhen.",
      phone: "(+86)0755-86703962",
    },
  ];

  const handleLogoClick = () => {
    navigate('/');
    window.scrollTo(0, 0);
  };

  return (
    <div className="footer-container">
      <div className="footer-content">
        {/* 顶部区域 */}
        <div className="top-section">
          {/* 左侧公司信息 */}
          <div className="company-info">
            <img 
              src="/images/home/u100.png" 
              alt="Logo" 
              className="logo" 
              onClick={handleLogoClick}
              style={{ cursor: 'pointer' }}
            />
          </div>

          {/* 右侧导航链接 */}
          <div className="navigation-columns">
            {navigationData.map((column, index) => (
              <div key={index} className="nav-column">
                <div className="nav-title">{column.title}</div>
                {column.links.map((link, linkIndex) => (
                  <div
                    key={linkIndex}
                    className="nav-link"
                    onClick={() => handleLinkClick(link.path)}
                  >
                    {link.label}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>

        {/* 底部区域 */}
        <div className="bottom-section">
          {/* 联系信息 */}
          <div className="contact-info">
            <div className="contact-item">
              <div className="locations-title">
                <img src="/images/home/email@4x.png" className="contact-icon" />
                <div className="locations-title-text">Email</div>
              </div>
              <div className="email-address">heils@heils.cn</div>
            </div>
            <div className="contact-item">
              <div className="locations-title">
                <img src="/images/home/location@4x.png" className="contact-icon" />
                <div className="locations-title-text">Location</div>
              </div>
              <div className="locations">
                {locations.map((location, index) => (
                  <div key={index} className="location-item">
                    <div className="location-title">{location.title}:</div>
                    <div className="location-address">
                      Address: {location.address}
                    </div>
                    <div className="location-phone">T: {location.phone}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* 版权信息 */}
        <div className="copyright">
          Copyright © Heils 2023. All rights reserved.
        </div>
      </div>
    </div>
  );
};

export default Footer;